import httpClient from "../httpClient";
import { API_CASE_UPDATE } from "../config";

const updateCaseInfo = {
    updateInfo: (id, data) => httpClient.post(API_CASE_UPDATE + '/' + id, data),
};

export default updateCaseInfo;
